import { t } from 'localization'
import { FC } from 'react'
import { SearchQA } from 'shared/dataAttributes'
import { colors, fonts } from 'shared/lib'
import styled from 'styled-components'

const TP = 'search.components.ClearRefinementsButton'

const Button = styled.button`
  border: none;
  background: none;
  margin: 0;
  ${fonts.CTA_TEXT_2}
  padding: 0 10px;

  &:disabled {
    color: ${colors.FC2_GREY};
  }
`
interface ClearRefinementsButtonProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  refine: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transformItems?: (...args: any[]) => any
}

const ClearRefinementsButton: FC<ClearRefinementsButtonProps> = ({ items, refine }) => {
  return items?.length > 0 ? (
    <Button
      data-qa={SearchQA.GridClearFiltersLink}
      onClick={() => {
        return refine?.(items)
      }}
      disabled={!items.length}
    >
      {t(`${TP}.clearFilters`, 'Clear Filters')}
    </Button>
  ) : (
    <></>
  )
}

export default ClearRefinementsButton
